export enum TravelInsuranceTypeEnum {
  Luggage = 'LUGGAGE',
  Nnw = 'NNW',
  Oc = 'OC',
  Sport = 'SPORT',
}
